/*
 * Footer parallax reveal — Osmo setup.
 * https://www.osmo.supply/resource/footer-parallax-effect
 *
 * As the footer scrolls into view its inner content is scrubbed from yPercent -25 → 0, so it
 * drifts up into place beneath the page — a parallax reveal. The wrapper is overflow-hidden, so
 * the offset is clipped. Requires gsap + ScrollTrigger (<head>).
 *
 * clamp() keeps the trigger within the page's scroll bounds (the footer is the last element, so
 * "top top" is otherwise unreachable). <wp-footer-parallax> (display: contents) wraps the footer;
 * built in connectedCallback inside gsap.matchMedia() (motion-allowed only — under reduced motion the
 * footer stays static) and reverted on disconnect. Trigger positions are re-measured by
 * smooth-scroll.js's post-font refresh and ScrollTrigger's own refresh on window load (after the
 * page's eager images, e.g. product galleries, have grown the page).
 */
(function () {
  if (!window.gsap || !window.ScrollTrigger || customElements.get('wp-footer-parallax')) return;

  class WpFooterParallax extends HTMLElement {
    connectedCallback() {
      const el = this.querySelector('[data-footer-parallax]');
      const inner = el && el.querySelector('[data-footer-parallax-inner]');
      if (!inner) return;

      this.mm = gsap.matchMedia();
      this.mm.add('(prefers-reduced-motion: no-preference)', () => {
        gsap
          .timeline({
            scrollTrigger: {
              trigger: el,
              start: 'clamp(top bottom)',
              end: 'clamp(top top)',
              scrub: true,
              // .from() records its start value when created, so a refresh must invalidate it —
              // otherwise re-measuring keeps animating from the stale offset.
              invalidateOnRefresh: true,
            },
          })
          .from(inner, { yPercent: -25, ease: 'none' });
      });
    }

    disconnectedCallback() {
      if (this.mm) this.mm.revert();
      this.mm = null;
    }
  }

  customElements.define('wp-footer-parallax', WpFooterParallax);
})();
